<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div style="margin: 0px 0px -6.5px 0px">
      <img
        src="https://wikipapa.org/images/banner-publicaciones.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      style="padding: 0% 15%; background-color: #fffee1"
    >
      <div fxFlex="100%">
        <p
          style="
            font-family: Raleway, sans-serif;
            color: #8b0032;
            font-size: 32pt;
            line-height: 61pt;
            text-align: center;
          "
        >
          Es una herramienta que permite consolidar la información acerca de
          agrobiodiversidad en un área determinada. Al mismo tiempo, esta
          herramienta permite compartir la información asociada a la
          agrobiodiversidad.
        </p>
      </div>
    </div>
    <div
      style="
        display: flex;
        max-width: 1170px;
        margin: 0px auto;
        padding: 0.75em;
        color: #96007c;
        font-size: 2.5em;
        align-items: center;
      "
    >
      <mat-icon style="height: 1em; width: 1em; font-size: 2em"
        >auto_stories</mat-icon
      >
      Catálogos
    </div>
    <div style="max-width: 1170px; margin: 0px auto; padding: 15px">
      <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <!-- == -->
        <div
          fxFlex="50"
          fxFlex.sm="100"
          fxFlex.xs="100"
          style="padding: 1em"
          *ngFor="let catalogPublication of catalogPublicationList"
        >
          <mat-card>
            <mat-card-content>
              <div style="margin: 0px 0px -6.5px 0px">
                <img
                  src="{{ catalogPublication.image_url }}"
                  style="object-fit: contain; background-size: cover"
                  width="100%"
                />
              </div>
              <div style="padding: 2em; min-height: 160px">
                <span
                  style="
                    color: #8b0032;
                    font-weight: 400;
                    font-size: 1.2em;

                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  title="{{ catalogPublication.content_text }}"
                >
                  {{ catalogPublication.content_text }} </span
                ><br /><br />
                <button
                  mat-flat-button
                  style="background-color: #96007c; color: #fff"
                  (click)="fnItem(catalogPublication.url_direction)"
                >
                  Leer mas...
                </button>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between start">
                <div fxFlex="33.3">
                  <div
                    style="
                      width: 100px;
                      height: 100px;
                      border: solid 4px #96007c;
                      border-radius: 50%;
                      margin: auto;
                      background: url(https://wikipapa.org/images/mapa-peru.jpg);
                      background-size: contain;
                      background-position: center;
                      background-repeat: no-repeat;
                    "
                    class="center-middle"
                  ></div>
                  <div style="padding: 10px; text-align: center">
                    <span
                      style="
                        color: #96007c;
                        font-weight: 400;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      title="{{ catalogPublication.text_1 }}"
                    >
                      {{ catalogPublication.text_1 }}</span
                    >
                  </div>
                </div>
                <div fxFlex="33.3">
                  <div
                    style="
                      width: 100px;
                      height: 100px;
                      border: solid 4px #96007c;
                      border-radius: 50%;
                      margin: auto;
                    "
                    class="center-middle"
                  >
                    <span
                      style="color: #96007c; font-weight: 700; font-size: 2em"
                      >{{ catalogPublication.val_2 }}</span
                    >
                  </div>
                  <div style="padding: 10px; text-align: center">
                    <span style="color: #96007c; font-weight: 400">{{
                      catalogPublication.text_2
                    }}</span>
                  </div>
                </div>
                <div fxFlex="33.3">
                  <div
                    style="
                      width: 100px;
                      height: 100px;
                      border: solid 4px #96007c;
                      border-radius: 50%;
                      margin: auto;
                    "
                    class="center-middle"
                  >
                    <span
                      style="color: #96007c; font-weight: 700; font-size: 2em"
                      >{{ catalogPublication.val_3 }}</span
                    >
                  </div>
                  <div style="padding: 10px; text-align: center">
                    <span style="color: #96007c; font-weight: 400">{{
                      catalogPublication.text_3
                    }}</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <!-- == -->
      </div>
    </div>
  </div>
</div>
